// api/documentApi.js
import apiClient, { downloadFile } from "../../../../../services/apiClient";

export const documentApi = {
  // Получение информации о документе
  getDocumentInfo: async (docId) => {
    const response = await apiClient.get(`content/doc_info_id?id_doc=${docId}`);
    return response.data;
  },

  // Скачивание файла документа
  downloadDocumentFile: async (docId, fileId, fileName) => {
    await downloadFile(`docfile?doc_id=${docId}&file_id=${fileId}`, fileName);
  },

  // Получение списка документов по типу
  getDocumentsByType: async (targetId, type) => {
    const response = await apiClient.get(`content/docs?target_id=${targetId}&type=${type}`);
    return response.data;
  }
};